


























































import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import {AddressTitle, CompanyType, Salutation} from "@/helpers/constants";
import AsiSelect from "./common/AsiSelect";
import AsiDialogFormLayout from "./common/AsiDialogFormLayout.vue";
import AsiDialogForm from "./common/AsiDialogForm.vue";
import AddressUpdate from "@/models/address/AddressUpdate";
import AddressBilling from "@/models/address/AddressBilling";
import AddressBillingUpdate from "@/models/address/AddressBillingUpdate";
import {enumToSelectItems} from "@/helpers/functions_asi";
import Address from "@/models/address/Address";
import User from "@/models/user/User";
import Company from "@/models/company/Company";
import {AxiosError} from "axios";
import AsiTextField from "@/components/common/AsiTextField";
import AsiCountryAutocompleteInput from "@/components/common/AsiCountryAutocompleteInput.vue";
import AsiCheckbox from "@/components/common/AsiCheckbox";

@Component({
	components: {AsiCheckbox, AsiCountryAutocompleteInput, AsiTextField, AsiDialogFormLayout, AsiSelect}
})
export default class AddressUpdateDialog extends AsiDialogForm {

	@Prop({type: Object, required: true})
	public address!: Address | AddressBilling;

	@Prop({type: Object, default: null})
	public user!: User | null;

	@Prop({type: Object, default: null})
	public company!: Company | null;

	protected companyTypes = CompanyType;
	private model: AddressUpdate | AddressBillingUpdate | null = null;
	private salutationOptions = enumToSelectItems(Salutation, true);
	private titleOptions = enumToSelectItems(AddressTitle, true);

	private get isBillingAddress(): boolean {
		return this.model !== null && this.model instanceof AddressBillingUpdate;
	}

	public created(): void {
		this.setAddressInternal();
	}

	@Emit('save')
	public save(event: Event): Event {
		return event;
	}

	@Emit('cancel')
	public cancel(event: Event): Event {
		this.setAddressInternal();
		const form = this.$refs.form as HTMLFormElement;
		this.reset([], form);
		return event;
	}

	@Watch('address', {deep: true})
	private onAddressChanged(): void {
		this.setAddressInternal();
	}

	private setAddressInternal(): void {
		if (this.address instanceof AddressBilling) {
			this.model = new AddressBillingUpdate(this.address);
		} else {
			this.model = new AddressUpdate(this.address);
		}
	}

	private requestSave(event: Event): void {
		if (this.model === null || (this.company === null && this.user === null)) return;

		if (this.company !== null) {
			if (this.model instanceof AddressBillingUpdate) {
				this.loading = true;
				this.$companyService.updateBillingAddress(this.company.id, this.model)
					.then(() => this.save(event))
					.catch((err: AxiosError) => {
						this.errors = err.response?.data;
					})
					.finally(() => {
						this.loading = false;
					});
			} else {
				this.loading = true;
				this.$companyService.updateContactAddress(this.company.id, this.model)
					.then(() => this.save(event))
					.catch((err: AxiosError) => {
						this.errors = err.response?.data;
					})
					.finally(() => {
						this.loading = false;
					});
			}
		}

		if (this.user !== null) {
			this.loading = true;
			this.$userService.updateAddress(this.user.id, this.model)
				.then(() => this.save(event))
				.catch((err: AxiosError) => {
					this.errors = err.response?.data;
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}

}
